export const ValveTypesDict = [
'6-way zone valve',
'Butterfly valve',
'Butterfly Valve', // am
'Characterised control valve',
'Characterised control valve, ball valve',
'Characterized control valve', // am
'Electronic pressure-independent characterised control valve',
'Electronic pressure-independent characterized control valve', // am
'Globe valve',
'Potable water valve',
'Pressure-independent 6-way zone valve',
'Pressure-independent Belimo Energy Valve™',
'Pressure-independent flow limiter valve',
'Pressure-independent zone valve',
'Zone valve',
'Ball valve',
] as const;

export type ValveType = typeof ValveTypesDict[number];

export const PressureIndependentValveTypes: ValveType[] = ValveTypesDict.filter((v) => !v.includes('independent') );
